<template>
  <div class="main-chart-block">
    <div class="total-summ-chart-block">
      <p class="total-summ-chart-title">
        {{ `${returnCurrencySymbol(getMainCurrency)} ${allSpent}` }}
      </p>
      <p v-if="activeAnalyticType === 'expense'" class="total-summ-chart-info">
        {{ $t("analytics.chartTotalSpent") }}
      </p>
      <p
        v-else-if="activeAnalyticType === 'income'"
        class="total-summ-chart-info"
      >
        {{ $t("analytics.chartTotalCost") }}
      </p>
      <p
        v-else-if="activeAnalyticType === 'transfer'"
        class="total-summ-chart-info"
      >
        {{ $t("analytics.chartTotalTransfer") }}
      </p>
    </div>
    <apexchart width="100%" type="donut" :options="options" :series="series">
    </apexchart>
  </div>
</template>

<script>
export default {
  name: "Analitycs-chart",
  components: {},
  props: {
    series: {
      type: Array,
      require: true,
    },
    options: {
      type: Object,
      require: true,
    },
    allSpent: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      currencySymbol: {
        1: "₴",
        2: "$",
        4: "€",
        6: "zł",
        7: "₴",
      },
    };
  },
  async mounted() {},

  methods: {
    returnCurrencySymbol(currency) {
      if (this.currencySymbol[currency.id]) {
        return this.currencySymbol[currency.id];
      } else {
        return currency.code_alfa;
      }
    },
    dataPointSelection: (event, chartContext, config) => {
      const { seriesIndex, dataPointIndex } = config;
      console.log(dataPointIndex);
      // Перевіряємо, чи обрана точка
      if (typeof seriesIndex !== "undefined") {
        const label = config.w.config.labels[seriesIndex];
        const value = config.w.globals.series[seriesIndex];

        alert(`Label: ${label}\nValue: ${value}`);
      }
    },
  },
  computed: {
    getMainCurrency() {
      return this.$store.getters.getMainCurrency;
    },
    activeAnalyticType() {
      return this.$store.getters.activeAnalyticType;
    },
  },
  watch: {},
};
</script>

<style scoped>
.main-chart-block {
  position: relative;
}

.total-summ-chart-block {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.total-summ-chart-title {
  font-size: 25px;
  line-height: 30px;
  font-weight: 700;
  color: #1b1b1b;
  font-family: "Source Sans 3", sans-serif;
  letter-spacing: -0.6px;
  text-align: center;
}

.total-summ-chart-info {
  font-size: 12px;
  opacity: 0.5;
  font-weight: 400;
  text-align: center;
  color: #1b1b1b;
  font-family: "Source Sans 3", sans-serif;
  letter-spacing: -0.6px;
}
</style>
